// Master-Hotfix P0 — long marketplace URLs must never break the layout.
// Visible label is shortened (`mobile.de · Inserat 461285717`), the href
// keeps the FULL original URL (tracking params stay functional).

const URL_RE = /(https?:\/\/[^\s<>()"']+)/g;
const MD_LINK_RE = /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g;

export function shortLinkLabel(url) {
  try {
    const u = new URL(url);
    const host = u.hostname.replace(/^www\./, "");
    const idMatch = `${u.pathname}?${u.search}`.match(/(\d{6,})/);
    if (idMatch) return `${host} · Inserat ${idMatch[1]}`;
    const seg = decodeURIComponent(
      (u.pathname.split("/").filter(Boolean).pop() || "").split("?")[0],
    );
    const short = seg.length > 26 ? `${seg.slice(0, 26)}…` : seg;
    return short ? `${host} · ${short}` : host;
  } catch {
    return url.length > 42 ? `${url.slice(0, 42)}…` : url;
  }
}

export function firstUrl(text) {
  const m = String(text || "").match(URL_RE);
  return m ? m[0].replace(/[.,;:!?]+$/, "") : null;
}

// Tokenize a message into text / link parts. Handles both markdown
// links `[label](url)` and bare URLs. Returns
// [{type:"text",value}|{type:"link",href,label}]
export function tokenizeMessage(text) {
  const out = [];
  const s = String(text || "");
  let last = 0;
  s.replace(MD_LINK_RE, (match, label, href, idx) => {
    if (idx > last) pushBare(out, s.slice(last, idx));
    out.push({ type: "link", href, label });
    last = idx + match.length;
    return match;
  });
  if (last < s.length) pushBare(out, s.slice(last));
  return out;
}

function pushBare(out, chunk) {
  const parts = chunk.split(URL_RE);
  for (const part of parts) {
    if (!part) continue;
    if (/^https?:\/\//.test(part)) {
      const clean = part.replace(/[.,;:!?]+$/, "");
      const rest = part.slice(clean.length);
      out.push({ type: "link", href: clean, label: shortLinkLabel(clean) });
      if (rest) out.push({ type: "text", value: rest });
    } else {
      out.push({ type: "text", value: part });
    }
  }
}
